export var ContextGLDrawMode;
(function (ContextGLDrawMode) {
    ContextGLDrawMode[ContextGLDrawMode["TRIANGLES"] = 0] = "TRIANGLES";
    ContextGLDrawMode[ContextGLDrawMode["LINES"] = 1] = "LINES";
})(ContextGLDrawMode || (ContextGLDrawMode = {}));
